const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/fair-use.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/fair-use")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  head: () => {
    return {
      meta: [{
        title: i18n.t("misc.fairUse.meta.title"),
        description: i18n.t("misc.fairUse.meta.description")
      }]
    };
  }
});